import { DEFAULT_LOCALE } from './Locales';
/**
 * Values from BE. Adding a new entry?
 * - Update all the places TS complains about in this file 😉
 * - Update {@link BRAND_ID_TO_UI_LABELS}
 */
var BrandId;
(function (BrandId) {
    BrandId["Alibaba"] = "e695b857-f5ab-45a5-8fce-275e5c75f2b8";
    BrandId["Avianca"] = "8562c7ba-b11d-46f1-b982-d7513500191f";
    BrandId["Avelo"] = "46d4f134-6a47-4368-88b3-23d01edeeabc";
    BrandId["Bilt"] = "9ed84ca0-a31e-485f-910a-a552bd47dbc8";
    BrandId["Cavs"] = "67f1bedf-ed56-4145-b8b0-45c9e97c2f0a";
    BrandId["Celtics"] = "005a51bd-2358-4210-b812-56e94dfd2b2e";
    BrandId["Coinbase"] = "e73051c5-a4c4-40fb-bc19-db38452f9c1b";
    BrandId["DemoPurple"] = "47918f4f-9b80-465e-8c91-e86189c0aa88";
    BrandId["EcommerceDemo"] = "a5dfee5a-0405-482e-803f-9b676978e0c0";
    BrandId["Hotel"] = "c1898170-b13a-43a2-bb9a-809be6a60f81";
    BrandId["LATAM"] = "8e0c09d7-e8e5-4688-a552-f2da5216a433";
    BrandId["LiverpoolFc"] = "4b060e46-9267-4022-a778-d19f301b4537";
    BrandId["ManUtd"] = "b9d48b86-7cf0-4527-83b9-b12e23fe45f1";
    BrandId["Marlins"] = "c12ddd7a-9980-44cd-adb5-ae7d842b95eb";
    BrandId["Pelicans"] = "6ee77ee4-cf93-4dcc-9c6a-29e3451caeca";
    BrandId["Qatar"] = "c31dab29-83f5-4150-91f6-7a329111d388";
    BrandId["Simon"] = "1041473f-0a1f-4743-974e-0feb147eef99";
    BrandId["TAPAirPortugal"] = "2a1f3774-226d-49cd-8518-38215ced1bf0";
    BrandId["Uber"] = "c5bd84ab-5aa3-449e-8832-2230ee79483a";
    BrandId["VisaDemo1"] = "a28e2ea0-5795-4955-9285-d839ff26f337";
    BrandId["VisaDemo2"] = "c61b0b11-313b-4805-afc9-4230be1e056e";
    BrandId["Kraken"] = "1200897f-6ed8-46b8-8a6e-56df0df7b269";
    BrandId["JetBlue"] = "e2049e79-6e60-4016-ba88-a9aeb6785ae3";
})(BrandId || (BrandId = {}));
/**
 * Values from BE. Adding a new entry?
 * - Update all the places TS complains about in this file 😉
 */
var BrandSlug;
(function (BrandSlug) {
    BrandSlug["Unspecified"] = "BRAND_SLUG_UNSPECIFIED";
    BrandSlug["Alibaba"] = "ALIBABA";
    BrandSlug["Avianca"] = "AVIANCA";
    BrandSlug["Avelo"] = "AVELO";
    BrandSlug["Bilt"] = "BILT";
    BrandSlug["Cavs"] = "CAVS";
    BrandSlug["Celtics"] = "CELTICS";
    BrandSlug["Coinbase"] = "COINBASE";
    BrandSlug["DemoPurple"] = "PURPLE";
    BrandSlug["EcommerceDemo"] = "ECOMMERCEDEMO";
    BrandSlug["Hotel"] = "HOTELDEMO";
    BrandSlug["LATAM"] = "LATAM";
    BrandSlug["LiverpoolFc"] = "LIVERPOOLFC";
    BrandSlug["ManUtd"] = "MANUTD";
    BrandSlug["Marlins"] = "MARLINS";
    BrandSlug["Pelicans"] = "PELICANS";
    BrandSlug["Qatar"] = "QATAR";
    BrandSlug["Simon"] = "SIMON";
    BrandSlug["TAPAirPortugal"] = "TAP";
    BrandSlug["Uber"] = "UBER";
    BrandSlug["VisaDemo1"] = "VISADEMO1";
    BrandSlug["VisaDemo2"] = "VISADEMO2";
    BrandSlug["Kraken"] = "KRAKEN";
    BrandSlug["JetBlue"] = "JETBLUE";
})(BrandSlug || (BrandSlug = {}));
/**
 * Values from BE
 */
const BRAND_ID_TO_SLUG = {
    [BrandId.Alibaba]: BrandSlug.Alibaba,
    [BrandId.Avianca]: BrandSlug.Avianca,
    [BrandId.Bilt]: BrandSlug.Bilt,
    [BrandId.Cavs]: BrandSlug.Cavs,
    [BrandId.Avelo]: BrandSlug.Avelo,
    [BrandId.Celtics]: BrandSlug.Celtics,
    [BrandId.Coinbase]: BrandSlug.Coinbase,
    [BrandId.DemoPurple]: BrandSlug.DemoPurple,
    [BrandId.EcommerceDemo]: BrandSlug.EcommerceDemo,
    [BrandId.Hotel]: BrandSlug.Hotel,
    [BrandId.LATAM]: BrandSlug.LATAM,
    [BrandId.LiverpoolFc]: BrandSlug.LiverpoolFc,
    [BrandId.ManUtd]: BrandSlug.ManUtd,
    [BrandId.Marlins]: BrandSlug.Marlins,
    [BrandId.Pelicans]: BrandSlug.Pelicans,
    [BrandId.Qatar]: BrandSlug.Qatar,
    [BrandId.Simon]: BrandSlug.Simon,
    [BrandId.TAPAirPortugal]: BrandSlug.TAPAirPortugal,
    [BrandId.Uber]: BrandSlug.Uber,
    [BrandId.VisaDemo1]: BrandSlug.VisaDemo1,
    [BrandId.VisaDemo2]: BrandSlug.VisaDemo2,
    [BrandId.Kraken]: BrandSlug.Kraken,
    [BrandId.JetBlue]: BrandSlug.JetBlue,
};
const BRAND_SLUG_TO_ID = Object.fromEntries(Object.entries(BRAND_ID_TO_SLUG).map((a) => a.reverse()));
var ProductId;
(function (ProductId) {
    ProductId["AlibabaCard"] = "b6cb2874-abdf-4247-bb52-5cfb025bd824";
    ProductId["AviancaLifemiles"] = "179ca609-4a18-4f4f-9f4a-70de303c2b23";
    ProductId["AviancaLifemilesElite"] = "353d67f6-27c6-4807-bd1b-dd3707c731c8";
    ProductId["BiltBlueCard"] = "0f0a20bb-01e8-4fc1-b3c3-8b52d239c6e2";
    ProductId["BiltObsidianCard"] = "668119f1-8202-45bc-a97a-e4321dda5af7";
    ProductId["BiltPalladiumCard"] = "7a7aa391-7a81-4f94-ada2-c070ab3acb0c";
    ProductId["BiltBlueCardConversion"] = "39ebdcb4-b636-497e-99d4-8e465cbf08f5";
    ProductId["BiltObsidianCardConversion"] = "44e485e1-d46e-4196-8e9f-68b03795be2b";
    ProductId["BiltPalladiumCardConversion"] = "9cdc0e07-3abb-4276-8a54-8919e7a4f25d";
    ProductId["CavsCard"] = "58e9c617-0efa-489f-94a6-41414387f826";
    ProductId["CoinbaseCard"] = "8be156f7-36b8-4c62-8382-507da9f027ca";
    ProductId["AveloWorldEliteCard"] = "56d64010-4d14-40fa-87bf-c94636b6ea72";
    ProductId["CelticsCard"] = "661a087f-43ad-4ed6-890e-6cf45ee0e55f";
    ProductId["EcommerceDemoCard"] = "b2aad4dc-65f3-4ae3-8836-98d03f566053";
    ProductId["HotelDemo"] = "b0074320-6671-4194-817f-d6748a6be8d0";
    ProductId["DemoPurpleGoldCard"] = "36279d61-a8cc-4882-9bf0-95dfc106fe30";
    ProductId["DemoPurpleSilverCard"] = "c5341668-843a-4237-ac34-41ecbdf4efd7";
    ProductId["LATAMCard"] = "c35cc38a-f1d3-4e3e-b81c-6059f8b7e598";
    ProductId["LATAMWorldEliteCard"] = "9e058e01-10cc-481b-be58-966185608718";
    ProductId["LiverpoolFcCard"] = "1b0bbc54-7cd6-4329-8223-30b6222da176";
    ProductId["ManUtdCard"] = "0a297e8d-b730-492a-a8e4-a2295a9d8e99";
    ProductId["MarlinsCard"] = "0c8ba844-9d82-4fe6-9c6c-f3df8d62ee82";
    ProductId["PelicansCard"] = "5b7b1c3c-ab97-48cb-bf2a-3a4eaa6a1f3a";
    ProductId["QatarPremiumCard"] = "98f4de06-b2c6-48a6-881b-33e431a2b64b";
    ProductId["QatarStandardCard"] = "78c85c9e-7d44-4955-84a4-87aa30484e06";
    ProductId["SimonCard"] = "ab1b07b0-ecc2-49ef-9917-49c11ebfdec5";
    ProductId["TAPAirPortugalCard"] = "45da1903-2ab1-496d-be70-1c498966f88a";
    ProductId["UberCard"] = "19f243d7-568c-4e02-9702-23858abe8877";
    ProductId["VisaDemo1Card"] = "eaa4c381-4375-44c9-8e75-8e481799c3e8";
    ProductId["VisaDemo2Card"] = "dd08437d-d0ca-42f4-85a4-969516feb46f";
    ProductId["KrakenCard"] = "1e1e232f-f0a5-4a87-a5a6-5bcf4d29a4cf";
    ProductId["JetBlueDebitCard"] = "b780aeb6-b28c-467c-847d-0c46d83f03ea";
})(ProductId || (ProductId = {}));
/**
 * Values from BE. Adding new entry?
 * - Update all the places TS complains about in this file 😉
 * - Update {@link PRODUCT_SLUG_TO_UI_LABELS}
 * - Update {@link PRODUCT_SLUG_TO_ACCOUNT_TYPE}
 * - Update {@link PRODUCT_SLUG_TO_COLORS} if theme values defined by design
 * - Add card art & apply flow assets to AWS S3 buckets for staging and prod `cardless-public-assets-staging`
 */
var ProductSlug;
(function (ProductSlug) {
    ProductSlug["AlibabaCard"] = "alibaba";
    ProductSlug["AviancaLifemilesElite"] = "avianca-lifemiles-elite";
    ProductSlug["AviancaLifemiles"] = "avianca-lifemiles";
    ProductSlug["AveloWorldEliteCard"] = "avelo";
    ProductSlug["BiltBlueCard"] = "bilt_blue";
    ProductSlug["BiltObsidianCard"] = "bilt_obsidian";
    ProductSlug["BiltPalladiumCard"] = "bilt_palladium";
    ProductSlug["BiltBlueCardConversion"] = "bilt_blue_conversion";
    ProductSlug["BiltObsidianCardConversion"] = "bilt_obsidian_conversion";
    ProductSlug["BiltPalladiumCardConversion"] = "bilt_palladium_conversion";
    ProductSlug["CavsCard"] = "cavs";
    ProductSlug["CelticsCard"] = "celtics";
    ProductSlug["CoinbaseCard"] = "coinbase";
    ProductSlug["DemoPurpleGoldCard"] = "purple-gold";
    ProductSlug["DemoPurpleSilverCard"] = "purple-silver";
    ProductSlug["EcommerceDemoCard"] = "ecommerce-demo";
    ProductSlug["HotelDemo"] = "hotel-demo";
    ProductSlug["LATAMCard"] = "latam-mastercard";
    ProductSlug["LATAMWorldEliteCard"] = "latam-world-elite";
    ProductSlug["LiverpoolFcCard"] = "liverpoolfc";
    ProductSlug["ManUtdCard"] = "manutd";
    ProductSlug["MarlinsCard"] = "marlins";
    ProductSlug["PelicansCard"] = "pelicans";
    ProductSlug["QatarPremiumCard"] = "qatar-premium";
    ProductSlug["QatarStandardCard"] = "qatar-standard";
    ProductSlug["SimonCard"] = "simon";
    ProductSlug["TAPAirPortugalCard"] = "tap-air-portugal";
    ProductSlug["UberCard"] = "uber-demo";
    ProductSlug["VisaDemo1Card"] = "visa-demo-1";
    ProductSlug["VisaDemo2Card"] = "visa-demo-2";
    ProductSlug["KrakenCard"] = "kraken";
    ProductSlug["JetBlueDebitCard"] = "jetblue-debit";
})(ProductSlug || (ProductSlug = {}));
const SUNSETTED_PRODUCTS = [
    ProductSlug.CavsCard,
    ProductSlug.CelticsCard,
    ProductSlug.LiverpoolFcCard,
    ProductSlug.ManUtdCard,
    ProductSlug.MarlinsCard,
    ProductSlug.PelicansCard,
    ProductSlug.SimonCard,
];
const PRODUCT_SLUG_TO_BRAND_ID = {
    [ProductSlug.AlibabaCard]: BrandId.Alibaba,
    [ProductSlug.AviancaLifemilesElite]: BrandId.Avianca,
    [ProductSlug.AviancaLifemiles]: BrandId.Avianca,
    [ProductSlug.AveloWorldEliteCard]: BrandId.Avelo,
    [ProductSlug.BiltBlueCard]: BrandId.Bilt,
    [ProductSlug.BiltObsidianCard]: BrandId.Bilt,
    [ProductSlug.BiltPalladiumCard]: BrandId.Bilt,
    [ProductSlug.BiltBlueCardConversion]: BrandId.Bilt,
    [ProductSlug.BiltObsidianCardConversion]: BrandId.Bilt,
    [ProductSlug.BiltPalladiumCardConversion]: BrandId.Bilt,
    [ProductSlug.CavsCard]: BrandId.Cavs,
    [ProductSlug.CelticsCard]: BrandId.Celtics,
    [ProductSlug.CoinbaseCard]: BrandId.Coinbase,
    [ProductSlug.DemoPurpleGoldCard]: BrandId.DemoPurple,
    [ProductSlug.DemoPurpleSilverCard]: BrandId.DemoPurple,
    [ProductSlug.EcommerceDemoCard]: BrandId.EcommerceDemo,
    [ProductSlug.HotelDemo]: BrandId.Hotel,
    [ProductSlug.LATAMCard]: BrandId.LATAM,
    [ProductSlug.LATAMWorldEliteCard]: BrandId.LATAM,
    [ProductSlug.LiverpoolFcCard]: BrandId.LiverpoolFc,
    [ProductSlug.ManUtdCard]: BrandId.ManUtd,
    [ProductSlug.MarlinsCard]: BrandId.Marlins,
    [ProductSlug.PelicansCard]: BrandId.Pelicans,
    [ProductSlug.QatarPremiumCard]: BrandId.Qatar,
    [ProductSlug.QatarStandardCard]: BrandId.Qatar,
    [ProductSlug.SimonCard]: BrandId.Simon,
    [ProductSlug.TAPAirPortugalCard]: BrandId.TAPAirPortugal,
    [ProductSlug.UberCard]: BrandId.Uber,
    [ProductSlug.VisaDemo1Card]: BrandId.VisaDemo1,
    [ProductSlug.VisaDemo2Card]: BrandId.VisaDemo2,
    [ProductSlug.KrakenCard]: BrandId.Kraken,
    [ProductSlug.JetBlueDebitCard]: BrandId.JetBlue,
};
const PRODUCT_ID_TO_SLUG = {
    [ProductId.AlibabaCard]: ProductSlug.AlibabaCard,
    [ProductId.AviancaLifemilesElite]: ProductSlug.AviancaLifemilesElite,
    [ProductId.AviancaLifemiles]: ProductSlug.AviancaLifemiles,
    [ProductId.AveloWorldEliteCard]: ProductSlug.AveloWorldEliteCard,
    [ProductId.BiltBlueCard]: ProductSlug.BiltBlueCard,
    [ProductId.BiltObsidianCard]: ProductSlug.BiltObsidianCard,
    [ProductId.BiltPalladiumCard]: ProductSlug.BiltPalladiumCard,
    [ProductId.BiltBlueCardConversion]: ProductSlug.BiltBlueCardConversion,
    [ProductId.BiltObsidianCardConversion]: ProductSlug.BiltObsidianCardConversion,
    [ProductId.BiltPalladiumCardConversion]: ProductSlug.BiltPalladiumCardConversion,
    [ProductId.CavsCard]: ProductSlug.CavsCard,
    [ProductId.CelticsCard]: ProductSlug.CelticsCard,
    [ProductId.CoinbaseCard]: ProductSlug.CoinbaseCard,
    [ProductId.DemoPurpleGoldCard]: ProductSlug.DemoPurpleGoldCard,
    [ProductId.DemoPurpleSilverCard]: ProductSlug.DemoPurpleSilverCard,
    [ProductId.EcommerceDemoCard]: ProductSlug.EcommerceDemoCard,
    [ProductId.HotelDemo]: ProductSlug.HotelDemo,
    [ProductId.LATAMCard]: ProductSlug.LATAMCard,
    [ProductId.LATAMWorldEliteCard]: ProductSlug.LATAMWorldEliteCard,
    [ProductId.LiverpoolFcCard]: ProductSlug.LiverpoolFcCard,
    [ProductId.ManUtdCard]: ProductSlug.ManUtdCard,
    [ProductId.MarlinsCard]: ProductSlug.MarlinsCard,
    [ProductId.PelicansCard]: ProductSlug.PelicansCard,
    [ProductId.QatarPremiumCard]: ProductSlug.QatarPremiumCard,
    [ProductId.QatarStandardCard]: ProductSlug.QatarStandardCard,
    [ProductId.SimonCard]: ProductSlug.SimonCard,
    [ProductId.TAPAirPortugalCard]: ProductSlug.TAPAirPortugalCard,
    [ProductId.UberCard]: ProductSlug.UberCard,
    [ProductId.VisaDemo1Card]: ProductSlug.VisaDemo1Card,
    [ProductId.VisaDemo2Card]: ProductSlug.VisaDemo2Card,
    [ProductId.KrakenCard]: ProductSlug.KrakenCard,
    [ProductId.JetBlueDebitCard]: ProductSlug.JetBlueDebitCard,
};
const PRIOR_CARD_ISSUER_CONFIG = {
    [ProductSlug.BiltBlueCard]: {
        issuer: 'Wells\u00a0Fargo',
        cardName: 'Bilt\u00a0Mastercard',
    },
    [ProductSlug.BiltObsidianCard]: {
        issuer: 'Wells\u00a0Fargo',
        cardName: 'Bilt\u00a0Mastercard',
    },
    [ProductSlug.BiltPalladiumCard]: {
        issuer: 'Wells\u00a0Fargo',
        cardName: 'Bilt\u00a0Mastercard',
    },
    [ProductSlug.BiltBlueCardConversion]: {
        issuer: 'Wells\u00a0Fargo',
        cardName: 'Bilt\u00a0Mastercard',
    },
    [ProductSlug.BiltObsidianCardConversion]: {
        issuer: 'Wells\u00a0Fargo',
        cardName: 'Bilt\u00a0Mastercard',
    },
    [ProductSlug.BiltPalladiumCardConversion]: {
        issuer: 'Wells\u00a0Fargo',
        cardName: 'Bilt\u00a0Mastercard',
    },
};
const PRODUCT_SLUG_TO_ID = Object.fromEntries(Object.entries(PRODUCT_ID_TO_SLUG).map((a) => a.reverse()));
const PRODUCT_MAP = Object.entries(PRODUCT_ID_TO_SLUG).reduce((coll, [productId, productSlug]) => {
    coll[productId] = productSlug;
    return coll;
}, {});
/** Own keys only, so inherited ones like `constructor` don't match */
const hasOwnKey = (record, key) => Object.prototype.hasOwnProperty.call(record, key);
function isBrandSlug(identifier) {
    return !!identifier && hasOwnKey(BRAND_SLUG_TO_ID, identifier);
}
function isBrandId(identifier) {
    return !!identifier && hasOwnKey(BRAND_ID_TO_SLUG, identifier);
}
function isProductSlug(identifier) {
    return !!identifier && hasOwnKey(PRODUCT_SLUG_TO_ID, identifier);
}
function isProductId(identifier) {
    return !!identifier && hasOwnKey(PRODUCT_ID_TO_SLUG, identifier);
}
const getProductIdFromPath = (pathname) => {
    for (const [key, data] of Object.entries(PRODUCT_MAP)) {
        if (pathname === data) {
            return key;
        }
    }
    return undefined;
};
const getBrandIdForProduct = (identifier) => {
    const identifierLower = identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase();
    switch (true) {
        case isProductId(identifier):
            return PRODUCT_SLUG_TO_BRAND_ID[PRODUCT_ID_TO_SLUG[identifier]];
        case isProductSlug(identifierLower):
            return PRODUCT_SLUG_TO_BRAND_ID[identifierLower];
        default:
            return undefined;
    }
};
const getBrandIdForBrand = (identifier) => {
    const identifierUpper = identifier === null || identifier === void 0 ? void 0 : identifier.toUpperCase();
    const identifierLower = identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase();
    switch (true) {
        case isBrandId(identifier):
            return identifier;
        case isBrandSlug(identifierUpper):
            return BRAND_SLUG_TO_ID[identifierUpper];
        case isProductId(identifier):
            return PRODUCT_SLUG_TO_BRAND_ID[PRODUCT_ID_TO_SLUG[identifier]];
        case isProductSlug(identifierLower):
            return PRODUCT_SLUG_TO_BRAND_ID[identifierLower];
        default:
            return undefined;
    }
};
const getBrandIdForIdentifier = (identifier) => {
    const brandId = getBrandIdForBrand(identifier) || getBrandIdForProduct(identifier);
    return brandId;
};
const getBrandSlugForIdentifier = (identifier) => {
    const identifierUpper = identifier === null || identifier === void 0 ? void 0 : identifier.toUpperCase();
    const identifierLower = identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase();
    switch (true) {
        case isBrandId(identifier):
            return BRAND_ID_TO_SLUG[identifier];
        case isBrandSlug(identifierUpper):
            return identifierUpper;
        case isProductId(identifier):
            return BRAND_ID_TO_SLUG[PRODUCT_SLUG_TO_BRAND_ID[PRODUCT_ID_TO_SLUG[identifier]]];
        case isProductSlug(identifierLower):
            return BRAND_ID_TO_SLUG[PRODUCT_SLUG_TO_BRAND_ID[identifierLower]];
        default:
            return undefined;
    }
};
const getProductIdForIdentifier = (identifier) => {
    var _a, _b;
    const identifierUpper = identifier === null || identifier === void 0 ? void 0 : identifier.toUpperCase();
    const identifierLower = identifier === null || identifier === void 0 ? void 0 : identifier.toLowerCase();
    switch (true) {
        case isBrandId(identifier):
            return PRODUCT_SLUG_TO_ID[(_a = Object.entries(PRODUCT_SLUG_TO_BRAND_ID).find(([, brandId]) => brandId === identifier)) === null || _a === void 0 ? void 0 : _a[0]];
        case isBrandSlug(identifierUpper):
            return PRODUCT_SLUG_TO_ID[(_b = Object.entries(PRODUCT_SLUG_TO_BRAND_ID).find(([, brandId]) => brandId === BRAND_SLUG_TO_ID[identifierUpper])) === null || _b === void 0 ? void 0 : _b[0]];
        case isProductId(identifier):
            return identifier;
        case isProductSlug(identifierLower):
            return PRODUCT_SLUG_TO_ID[identifierLower];
        default:
            return undefined;
    }
};
function getProductSlugForIdentifier(identifier) {
    var _a, _b;
    switch (true) {
        case isBrandId(identifier):
            return (_a = Object.entries(PRODUCT_SLUG_TO_BRAND_ID).find(([, brandId]) => brandId === identifier)) === null || _a === void 0 ? void 0 : _a[0];
        case isBrandSlug(identifier):
            return (_b = Object.entries(PRODUCT_SLUG_TO_BRAND_ID).find(([, brandId]) => brandId === BRAND_SLUG_TO_ID[identifier])) === null || _b === void 0 ? void 0 : _b[0];
        case isProductId(identifier):
            return PRODUCT_ID_TO_SLUG[identifier];
        case isProductSlug(identifier):
            return identifier;
        default:
            return undefined;
    }
}
function getPriorCardIssuerConfigForIdentifier(identifier) {
    const productSlug = getProductSlugForIdentifier(identifier);
    return productSlug ? PRIOR_CARD_ISSUER_CONFIG[productSlug] : undefined;
}
/** @deprecated */
const isLatamCheckoutCampaign = (campaign) => {
    return campaign === 'latam-checkout-150-40k';
};
const TRAVEL_PRODUCTS = [
    ProductId.AviancaLifemilesElite,
    ProductId.AviancaLifemiles,
    ProductId.AveloWorldEliteCard,
    ProductId.DemoPurpleGoldCard,
    ProductId.JetBlueDebitCard,
    ProductId.LATAMCard,
    ProductId.LATAMWorldEliteCard,
    ProductId.QatarPremiumCard,
    ProductId.QatarStandardCard,
    ProductId.TAPAirPortugalCard,
];
const isProductCategoryTravel = (productIdentifier) => {
    if (!productIdentifier) {
        return false;
    }
    else if (TRAVEL_PRODUCTS.includes(productIdentifier)) {
        return true;
    }
    else {
        return TRAVEL_PRODUCTS.map((id) => PRODUCT_ID_TO_SLUG[id]).includes(productIdentifier);
    }
};
const BILT_APP_STORE_CONFIG = {
    appStoreName: 'Bilt Rewards',
    appStoreUrl: 'https://apps.apple.com/us/app/id1532270655',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.biltrewards.bilt',
    downloadUrl: 'https://bilt.com/l/appstore',
    privacyPolicy: {
        url: 'https://legal.biltrewards.com/policies?name=bilt-technologies-inc-privacy-policy',
        name: 'Bilt Technologies, Inc. Privacy Policy',
    },
};
const PRODUCT_SLUG_TO_APP_STORE_CONFIG = {
    [ProductSlug.AveloWorldEliteCard]: {
        appStoreName: 'Avelo',
        appStoreUrl: 'https://apps.apple.com/us/app/id1563684926',
        playStoreUrl: 'https://play.google.com/store/apps/details?id=com.Avelo.app',
        downloadUrl: 'https://www.aveloair.com/download-avelo-mobile-app',
        privacyPolicy: {
            url: 'https://www.aveloair.com/privacy-policy',
            name: 'Avelo Privacy Policy',
        },
    },
    [ProductSlug.BiltBlueCard]: BILT_APP_STORE_CONFIG,
    [ProductSlug.BiltObsidianCard]: BILT_APP_STORE_CONFIG,
    [ProductSlug.BiltPalladiumCard]: BILT_APP_STORE_CONFIG,
    [ProductSlug.BiltBlueCardConversion]: BILT_APP_STORE_CONFIG,
    [ProductSlug.BiltObsidianCardConversion]: BILT_APP_STORE_CONFIG,
    [ProductSlug.BiltPalladiumCardConversion]: BILT_APP_STORE_CONFIG,
    [ProductSlug.CoinbaseCard]: {
        appStoreName: 'Coinbase',
        appStoreUrl: 'https://apps.apple.com/us/app/id886427730',
        playStoreUrl: 'https://play.google.com/store/apps/details?id=com.coinbase.android',
        downloadUrl: 'https://www.coinbase.com/setup',
        privacyPolicy: undefined,
    },
    [ProductSlug.JetBlueDebitCard]: {
        appStoreName: 'JetBlue',
        appStoreUrl: 'https://apps.apple.com/us/app/id481370590',
        playStoreUrl: 'https://play.google.com/store/apps/details?id=com.jetblue.JetBlueAndroid',
        downloadUrl: 'https://www.jetblue.com/mobile-app',
        privacyPolicy: {
            url: 'https://www.jetblue.com/legal/privacy',
            name: 'JetBlue Privacy Policy',
        },
    },
    cardless: {
        appStoreName: 'Cardless',
        appStoreUrl: 'https://apps.apple.com/us/app/id1532270655',
        playStoreUrl: 'https://play.google.com/store/apps/details?id=com.cardless.consumer',
        downloadUrl: 'https://go.cardless.com/LkKOvlvzSCb',
        privacyPolicy: {
            url: 'https://www.cardless.com/privacy-policy',
            name: 'CardlessPrivacy Policy',
        },
    },
};
/**
 * Would we love for this to be owned by a config served up by BE? Yes.
 * But these values also don't change often, and we want to leverage super-speedy,
 * no-conflict server- vs client-rendering without hydration mismatches
 */
const PRODUCT_SLUG_TO_UI_LABELS = {
    [ProductSlug.AlibabaCard]: {
        name: {
            longhand: 'Alibaba.com Business Edge Credit\u00a0Card',
            shorthand: 'Alibaba.com Business\u00a0Card',
        },
    },
    [ProductSlug.AviancaLifemilesElite]: {
        name: {
            longhand: 'avianca lifemiles American\u00a0Express® Elite\u00a0Card',
            shorthand: 'avianca lifemiles Elite\u00a0Card',
        },
    },
    [ProductSlug.AviancaLifemiles]: {
        name: {
            longhand: 'avianca lifemiles American\u00a0Express®\u00a0Card',
            shorthand: 'avianca lifemiles\u00a0Card',
        },
    },
    [ProductSlug.AveloWorldEliteCard]: {
        name: {
            longhand: 'Avelo Airlines World\u00a0Elite Mastercard',
            shorthand: 'Avelo\u00a0Airlines\u00a0Mastercard',
        },
    },
    [ProductSlug.BiltBlueCard]: {
        name: {
            longhand: 'Bilt Blue\u00a0Card',
            shorthand: 'Blue\u00a0Card',
        },
    },
    [ProductSlug.BiltObsidianCard]: {
        name: {
            longhand: 'Bilt Obsidian\u00a0Card',
            shorthand: 'Obsidian\u00a0Card',
        },
    },
    [ProductSlug.BiltPalladiumCard]: {
        name: {
            longhand: 'Bilt Palladium\u00a0Card',
            shorthand: 'Palladium\u00a0Card',
        },
    },
    [ProductSlug.BiltBlueCardConversion]: {
        name: {
            longhand: 'Bilt Blue\u00a0Card',
            shorthand: 'Blue\u00a0Card',
        },
    },
    [ProductSlug.BiltObsidianCardConversion]: {
        name: {
            longhand: 'Bilt Obsidian\u00a0Card',
            shorthand: 'Obsidian\u00a0Card',
        },
    },
    [ProductSlug.BiltPalladiumCardConversion]: {
        name: {
            longhand: 'Bilt Palladium\u00a0Card',
            shorthand: 'Palladium\u00a0Card',
        },
    },
    [ProductSlug.CavsCard]: {
        name: {
            longhand: 'Cleveland Cavaliers Credit\u00a0Card',
            shorthand: 'Cavs\u00a0Card',
        },
    },
    [ProductSlug.CelticsCard]: {
        name: {
            longhand: 'Celtics Credit\u00a0Card',
            shorthand: 'Celtics\u00a0Card',
        },
    },
    [ProductSlug.DemoPurpleGoldCard]: {
        name: {
            longhand: 'Purple Gold Airlines American\u00a0Express® Credit\u00a0Card',
            shorthand: 'Purple Gold\u00a0Card',
        },
    },
    [ProductSlug.DemoPurpleSilverCard]: {
        name: {
            longhand: 'Purple Silver American\u00a0Express® Credit\u00a0Card',
            shorthand: 'Purple Silver\u00a0Card',
        },
    },
    [ProductSlug.EcommerceDemoCard]: {
        name: {
            longhand: 'Fanatics Credit\u00a0Card',
            shorthand: 'Fanatics credit\u00a0card',
        },
    },
    [ProductSlug.HotelDemo]: {
        name: {
            longhand: 'Omni Hotels Credit Card',
            shorthand: 'Omni Hotels Card',
        },
    },
    [ProductSlug.LATAMCard]: {
        name: {
            longhand: 'LATAM Airlines Mastercard',
            shorthand: 'LATAM\u00a0Mastercard',
        },
    },
    [ProductSlug.LATAMWorldEliteCard]: {
        name: {
            longhand: 'LATAM Airlines World\u00a0Elite Mastercard',
            shorthand: 'LATAM World Elite Mastercard',
        },
    },
    [ProductSlug.LiverpoolFcCard]: {
        name: {
            longhand: 'Liverpool FC Credit\u00a0Card',
            shorthand: 'Liverpool Card',
        },
    },
    [ProductSlug.ManUtdCard]: {
        name: {
            longhand: 'Manchester United Credit\u00a0Card',
            shorthand: 'Man\u00a0Utd\u00a0Card',
        },
    },
    [ProductSlug.MarlinsCard]: {
        name: {
            longhand: 'Marlins Credit\u00a0Card',
            shorthand: 'Marlins\u00a0Card',
        },
    },
    [ProductSlug.PelicansCard]: {
        name: {
            longhand: 'Pelicans Credit\u00a0Card',
            shorthand: 'Pelicans\u00a0Card',
        },
    },
    [ProductSlug.QatarPremiumCard]: {
        name: {
            longhand: 'Qatar Airways Privilege\u00a0Club\u00a0Infinite Credit\u00a0Card',
            shorthand: 'Privilege Club credit\u00a0card',
        },
    },
    [ProductSlug.QatarStandardCard]: {
        name: {
            longhand: 'Qatar Airways Privilege\u00a0Club\u00a0Signature Credit\u00a0Card',
            shorthand: 'Privilege Club credit\u00a0card',
        },
    },
    [ProductSlug.SimonCard]: {
        name: {
            longhand: 'Simon® American\u00a0Express® Credit\u00a0Card',
            shorthand: 'Simon®\u00a0Card',
        },
    },
    [ProductSlug.UberCard]: {
        name: {
            longhand: 'Uber One Credit Card',
            shorthand: 'Uber Card',
        },
    },
    [ProductSlug.TAPAirPortugalCard]: {
        name: {
            longhand: 'TAP Miles&Go American\u00a0Express® Credit\u00a0Card',
            shorthand: 'TAP Miles&Go\u00a0Card',
        },
    },
    [ProductSlug.VisaDemo1Card]: {
        name: {
            longhand: 'Samsung Credit Card',
            shorthand: 'Samsung Card',
        },
    },
    [ProductSlug.VisaDemo2Card]: {
        name: {
            longhand: 'Sunoco Credit Card',
            shorthand: 'Sunoco Card',
        },
    },
    [ProductSlug.CoinbaseCard]: {
        name: {
            longhand: 'Coinbase\u00a0One Credit\u00a0Card',
            shorthand: 'Coinbase\u00a0One Card',
        },
    },
    [ProductSlug.KrakenCard]: {
        name: {
            longhand: 'Krak Credit\u00a0Card',
            shorthand: 'Krak Credit\u00a0Card',
        },
    },
    [ProductSlug.JetBlueDebitCard]: {
        name: {
            longhand: 'JetBlue\u00a0Card',
            shorthand: 'JetBlue\u00a0Card',
        },
    },
};
/**
 * Absolute URL to brand's authentication screen (login/sign up)
 *
 * These vanity URLs are managed by www.cardless.com's next.config rather
 * than being hard-coded here. Doing so allows us to deploy quick changes
 * to `www` rather than the full suite of product surfaces due to a
 * shared package update
 */
const getAuthProductUrlForBrand = (brandId, env = 'production') => {
    const brandSlug = BRAND_ID_TO_SLUG[brandId];
    if (BrandSlug.Alibaba === brandSlug) {
        return `https://www.cardless${env === 'production' ? '' : '-staging'}.com/cards/${brandSlug.toLowerCase()}/partner/auth-product-url`;
    }
    else {
        return undefined;
    }
};
/**
 * Would we love for this to be owned by a config served up by BE? Yes.
 * But these values also don't change often, and we want to leverage super-speedy,
 * no-conflict server- vs client-rendering without hydration mismatches
 */
const BRAND_ID_TO_UI_LABELS = {
    [BrandId.Alibaba]: {
        name: {
            longhand: 'Alibaba.com',
            shorthand: 'Alibaba.com',
        },
        loyaltyProgram: {
            longhand: 'Alibaba.com',
            shorthand: 'Alibaba.com',
            forms: {
                [DEFAULT_LOCALE]: {
                    loyaltyId: {
                        productName: 'Alibaba.com account',
                        label: 'Enter your member ID',
                        placeholder: 'Member ID',
                        validationHelpText: 'Please enter a valid member ID',
                    },
                },
            },
        },
    },
    [BrandId.Avianca]: {
        name: {
            longhand: 'avianca',
            shorthand: 'avianca',
        },
        loyaltyProgram: {
            longhand: 'lifemiles',
            shorthand: 'lifemiles',
            forms: {
                [DEFAULT_LOCALE]: {
                    loyaltyId: {
                        productName: 'lifemiles account',
                        label: 'Enter your lifemiles number',
                        placeholder: 'lifemiles number',
                        validationHelpText: 'Please enter a valid lifemiles number',
                    },
                },
                validation: {
                    loyaltyIdPatternFormat: '###########',
                    loyaltyIdRegExp: /^\d{2,11}$/,
                    loyaltyIdRefinement(v) {
                        const potentiallyCorrect = /^\d{2,11}$/.test(v);
                        if (potentiallyCorrect) {
                            const expectedCheckDigit = Number(v.substring(v.length - 1));
                            const valueWithLastDigitRemoved = Number(v.substring(0, v.length - 1));
                            const intValueDividedOut = Math.floor(valueWithLastDigitRemoved / 7);
                            const checkDigit = valueWithLastDigitRemoved - intValueDividedOut * 7;
                            return (checkDigit === expectedCheckDigit &&
                                checkDigit >= 0 &&
                                checkDigit <= 7);
                        }
                        else {
                            return false;
                        }
                    },
                },
            },
        },
    },
    [BrandId.Avelo]: {
        name: {
            longhand: 'Avelo Airlines',
            shorthand: 'Avelo',
        },
    },
    [BrandId.Bilt]: {
        name: {
            longhand: 'Bilt Rewards',
            shorthand: 'Bilt',
        },
    },
    [BrandId.Coinbase]: {
        name: {
            longhand: 'Coinbase',
            shorthand: 'Coinbase',
        },
    },
    [BrandId.DemoPurple]: {
        name: {
            longhand: 'Purple',
            shorthand: 'Purple',
        },
    },
    [BrandId.EcommerceDemo]: {
        name: {
            longhand: 'Fanatics',
            shorthand: 'Fanatics',
        },
    },
    [BrandId.LATAM]: {
        name: {
            longhand: 'LATAM Airlines',
            shorthand: 'LATAM',
        },
        loyaltyProgram: {
            longhand: 'LATAM\u00a0Pass',
            shorthand: 'LATAM\u00a0Pass',
            forms: {
                [DEFAULT_LOCALE]: {
                    loyaltyId: {
                        productName: 'LATAM\u00a0Pass account',
                        label: 'Enter your LATAM\u00a0Pass number',
                        placeholder: 'Membership number',
                        validationHelpText: 'Please enter a 12-digit value',
                    },
                },
                validation: {
                    loyaltyIdPatternFormat: '############',
                    loyaltyIdRegExp: /^\d{12}$/,
                },
            },
        },
    },
    [BrandId.Qatar]: {
        name: {
            longhand: 'Qatar\u00a0Airways',
            shorthand: 'Qatar\u00a0Airways',
        },
        loyaltyProgram: {
            longhand: 'Privilege\u00a0Club',
            shorthand: 'Privilege\u00a0Club',
            forms: {
                [DEFAULT_LOCALE]: {
                    loyaltyId: {
                        productName: 'Privilege Club account',
                        label: 'Enter your Privilege Club number',
                        placeholder: 'Privilege Club number',
                        validationHelpText: 'Please enter a 9-digit value',
                        lookupHelpText: `
              <ol>
                <li><a href="https://www.qatarairways.com/en/Privilege-Club/login.mobile.html" target="_blank" rel="noreferrer noopener">Log in</a> to your Privilege\u00a0Club account</li>
                <li>Go to your Profile → Edit Profile, or select the "⚙️" icon</li>
                <li>Link your account using the same phone number and email address</li>
              </ol>`,
                    },
                },
                validation: {
                    loyaltyIdPatternFormat: '### ### ###',
                    loyaltyIdRegExp: /^\d{9}$/,
                },
            },
        },
    },
    [BrandId.Simon]: {
        name: {
            longhand: 'Simon',
            shorthand: 'Simon',
        },
    },
    [BrandId.TAPAirPortugal]: {
        name: {
            longhand: 'TAP\u00a0Air\u00a0Portugal',
            shorthand: 'TAP',
        },
        loyaltyProgram: {
            longhand: 'TAP\u00a0Miles&Go',
            shorthand: 'Miles&Go',
            forms: {
                [DEFAULT_LOCALE]: {
                    loyaltyId: {
                        productName: 'Miles&Go account',
                        label: 'Enter your Miles&Go account number',
                        placeholder: 'Client number',
                        validationHelpText: 'Please enter a 9-digit value',
                    },
                },
                validation: {
                    loyaltyIdRegExp: /^\d{9}$/,
                    loyaltyIdPatternFormat: '### ### ###',
                },
            },
        },
    },
    [BrandId.Uber]: {
        name: {
            longhand: 'Uber',
            shorthand: 'Uber',
        },
    },
    [BrandId.VisaDemo1]: {
        name: {
            longhand: 'Samsung',
            shorthand: 'Samsung',
        },
    },
    [BrandId.VisaDemo2]: {
        name: {
            longhand: 'Sunoco',
            shorthand: 'Sunoco',
        },
    },
    [BrandId.Kraken]: {
        name: {
            longhand: 'Kraken',
            shorthand: 'Kraken',
        },
    },
    [BrandId.JetBlue]: {
        name: {
            longhand: 'JetBlue',
            shorthand: 'JetBlue',
        },
    },
};
const getStartsWithVowel = (word) => {
    return !!word && /^[aeiou]/i.test(word);
};
const getUIProductLabels = (productSlug) => {
    const maybeLabels = productSlug
        ? PRODUCT_SLUG_TO_UI_LABELS[productSlug]
        : undefined;
    return maybeLabels;
};
const getUIProductName = (productSlug) => {
    var _a;
    return (_a = getUIProductLabels(productSlug)) === null || _a === void 0 ? void 0 : _a.name.longhand;
};
const getUIProductShortName = (productSlug) => {
    var _a;
    return (_a = getUIProductLabels(productSlug)) === null || _a === void 0 ? void 0 : _a.name.shorthand;
};
const getUIBrandLabels = (brandId) => {
    const maybeLabels = brandId
        ? BRAND_ID_TO_UI_LABELS[brandId]
        : undefined;
    return maybeLabels;
};
const getUIBrandName = (brandId) => {
    const maybeLabels = getUIBrandLabels(brandId);
    return maybeLabels === null || maybeLabels === void 0 ? void 0 : maybeLabels.name.longhand;
};
const getUIBrandShortName = (brandId) => {
    const maybeLabels = getUIBrandLabels(brandId);
    return maybeLabels === null || maybeLabels === void 0 ? void 0 : maybeLabels.name.shorthand;
};
const getUIBrandLoyaltyProgram = (brandId) => {
    const maybeLabels = getUIBrandLabels(brandId);
    return maybeLabels === null || maybeLabels === void 0 ? void 0 : maybeLabels.loyaltyProgram;
};
const getUIBrandLoyaltyFormConfig = (brandId, locale = DEFAULT_LOCALE) => {
    var _a, _b, _c;
    const form = (_b = (_a = getUIBrandLabels(brandId)) === null || _a === void 0 ? void 0 : _a.loyaltyProgram) === null || _b === void 0 ? void 0 : _b.forms;
    const labels = locale && form
        ? ((_c = form[locale]) !== null && _c !== void 0 ? _c : form[DEFAULT_LOCALE])
        : undefined;
    return labels
        ? Object.assign(Object.assign({}, labels), { validation: form === null || form === void 0 ? void 0 : form.validation }) : undefined;
};
const isSunsettedProduct = (productSlug) => {
    return SUNSETTED_PRODUCTS.includes(productSlug);
};
const CASH_BACK_PRODUCTS = [
    ProductId.SimonCard,
    ProductId.AlibabaCard,
];
const isCashBackProduct = (productSlugOrId) => {
    let productId;
    if (productSlugOrId && productSlugOrId in PRODUCT_SLUG_TO_ID) {
        productId = PRODUCT_SLUG_TO_ID[productSlugOrId];
    }
    else if (productSlugOrId && productSlugOrId in PRODUCT_ID_TO_SLUG) {
        productId = productSlugOrId;
    }
    if (productId) {
        return CASH_BACK_PRODUCTS.includes(productId);
    }
    else {
        return false;
    }
};
/**
 * Backend points types for products with their own rewards programs; other products use `cardless`.
 * These identify stored balances, not UI labels: Qatar stores `qatar` and displays Avios.
 */
const PRODUCT_POINTS_TYPES = {
    [ProductId.DemoPurpleGoldCard]: 'purple',
    [ProductId.DemoPurpleSilverCard]: 'purple',
    [ProductId.LATAMCard]: 'latam',
    [ProductId.LATAMWorldEliteCard]: 'latam',
    [ProductId.QatarPremiumCard]: 'qatar',
    [ProductId.QatarStandardCard]: 'qatar',
    [ProductId.AviancaLifemiles]: 'avianca',
    [ProductId.AviancaLifemilesElite]: 'avianca',
    [ProductId.TAPAirPortugalCard]: 'tap',
    [ProductId.AveloWorldEliteCard]: 'avelo',
    [ProductId.JetBlueDebitCard]: 'jetblue',
};
function getProductPointsType(productId) {
    var _a;
    const pointsTypes = PRODUCT_POINTS_TYPES;
    return (_a = pointsTypes[productId]) !== null && _a !== void 0 ? _a : 'cardless';
}
/** Balance and billing model of a product or account */
var AccountType;
(function (AccountType) {
    AccountType["Unspecified"] = "ACCOUNT_TYPE_UNSPECIFIED";
    AccountType["RevolvingCredit"] = "ACCOUNT_TYPE_REVOLVING_CREDIT";
    AccountType["Debit"] = "ACCOUNT_TYPE_DEBIT";
})(AccountType || (AccountType = {}));
/**
 * Mirrors the backend's `GetProductFeaturesResponse.account_type`; keep in sync with it.
 * Lets the UI know debit vs credit from the slug alone, with no network wait
 */
const PRODUCT_SLUG_TO_ACCOUNT_TYPE = {
    [ProductSlug.AlibabaCard]: AccountType.RevolvingCredit,
    [ProductSlug.AviancaLifemilesElite]: AccountType.RevolvingCredit,
    [ProductSlug.AviancaLifemiles]: AccountType.RevolvingCredit,
    [ProductSlug.AveloWorldEliteCard]: AccountType.RevolvingCredit,
    [ProductSlug.BiltBlueCard]: AccountType.RevolvingCredit,
    [ProductSlug.BiltObsidianCard]: AccountType.RevolvingCredit,
    [ProductSlug.BiltPalladiumCard]: AccountType.RevolvingCredit,
    [ProductSlug.BiltBlueCardConversion]: AccountType.RevolvingCredit,
    [ProductSlug.BiltObsidianCardConversion]: AccountType.RevolvingCredit,
    [ProductSlug.BiltPalladiumCardConversion]: AccountType.RevolvingCredit,
    [ProductSlug.CavsCard]: AccountType.RevolvingCredit,
    [ProductSlug.CelticsCard]: AccountType.RevolvingCredit,
    [ProductSlug.CoinbaseCard]: AccountType.RevolvingCredit,
    [ProductSlug.DemoPurpleGoldCard]: AccountType.RevolvingCredit,
    [ProductSlug.DemoPurpleSilverCard]: AccountType.RevolvingCredit,
    [ProductSlug.EcommerceDemoCard]: AccountType.RevolvingCredit,
    [ProductSlug.HotelDemo]: AccountType.RevolvingCredit,
    [ProductSlug.LATAMCard]: AccountType.RevolvingCredit,
    [ProductSlug.LATAMWorldEliteCard]: AccountType.RevolvingCredit,
    [ProductSlug.LiverpoolFcCard]: AccountType.RevolvingCredit,
    [ProductSlug.ManUtdCard]: AccountType.RevolvingCredit,
    [ProductSlug.MarlinsCard]: AccountType.RevolvingCredit,
    [ProductSlug.PelicansCard]: AccountType.RevolvingCredit,
    [ProductSlug.QatarPremiumCard]: AccountType.RevolvingCredit,
    [ProductSlug.QatarStandardCard]: AccountType.RevolvingCredit,
    [ProductSlug.SimonCard]: AccountType.RevolvingCredit,
    [ProductSlug.TAPAirPortugalCard]: AccountType.RevolvingCredit,
    [ProductSlug.UberCard]: AccountType.RevolvingCredit,
    [ProductSlug.VisaDemo1Card]: AccountType.RevolvingCredit,
    [ProductSlug.VisaDemo2Card]: AccountType.RevolvingCredit,
    [ProductSlug.KrakenCard]: AccountType.RevolvingCredit,
    [ProductSlug.JetBlueDebitCard]: AccountType.Debit,
};
const getProductAccountType = (productSlugOrId) => {
    if (isProductId(productSlugOrId)) {
        return PRODUCT_SLUG_TO_ACCOUNT_TYPE[PRODUCT_ID_TO_SLUG[productSlugOrId]];
    }
    else if (isProductSlug(productSlugOrId)) {
        return PRODUCT_SLUG_TO_ACCOUNT_TYPE[productSlugOrId];
    }
    else {
        return undefined;
    }
};
var CardNetwork;
(function (CardNetwork) {
    CardNetwork["Unspecified"] = "CARD_NETWORK_UNSPECIFIED";
    CardNetwork["AmericanExpress"] = "AMERICAN_EXPRESS";
    CardNetwork["Visa"] = "VISA";
    CardNetwork["Mastercard"] = "MASTERCARD";
})(CardNetwork || (CardNetwork = {}));
var CardNetworkVariant;
(function (CardNetworkVariant) {
    CardNetworkVariant["Unspecified"] = "CARD_NETWORK_VARIANT_UNSPECIFIED";
    CardNetworkVariant["MastercardPremium"] = "MASTERCARD_PREMIUM";
    CardNetworkVariant["MastercardWorldEliteBusiness"] = "MASTERCARD_WORLD_ELITE_BUSINESS";
    CardNetworkVariant["VisaSignature"] = "VISA_SIGNATURE";
    CardNetworkVariant["VisaInfinite"] = "VISA_INFINITE";
})(CardNetworkVariant || (CardNetworkVariant = {}));
const BRAND_UUID_TO_CARD_NETWORK = {};
function getCreditCardNetworkForProductId(productId) {
    const brandUuid = getBrandIdForProduct(productId);
    if (brandUuid && brandUuid in BRAND_UUID_TO_CARD_NETWORK) {
        return BRAND_UUID_TO_CARD_NETWORK[brandUuid];
    }
    switch (brandUuid) {
        case BrandId.Avianca:
        case BrandId.Coinbase:
        case BrandId.Simon:
        case BrandId.TAPAirPortugal:
            return CardNetwork.AmericanExpress;
        case BrandId.Kraken:
        case BrandId.Qatar:
        case BrandId.Uber:
        case BrandId.VisaDemo1:
        case BrandId.VisaDemo2:
            return CardNetwork.Visa;
        default:
            return CardNetwork.Mastercard;
    }
}
const PRODUCT_ID_TO_CARD_NETWORK_VARIANT = {};
function getCreditCardNetworkVariantForProductId(productId) {
    if (productId in PRODUCT_ID_TO_CARD_NETWORK_VARIANT) {
        return PRODUCT_ID_TO_CARD_NETWORK_VARIANT[productId];
    }
    switch (productId) {
        case ProductId.LATAMWorldEliteCard:
        case ProductId.AlibabaCard:
        case ProductId.AveloWorldEliteCard:
        case ProductId.BiltBlueCard:
        case ProductId.BiltObsidianCard:
        case ProductId.BiltPalladiumCard:
        case ProductId.BiltBlueCardConversion:
        case ProductId.BiltObsidianCardConversion:
        case ProductId.BiltPalladiumCardConversion:
            return CardNetworkVariant.MastercardWorldEliteBusiness;
        case ProductId.QatarPremiumCard:
            return CardNetworkVariant.VisaInfinite;
        case ProductId.QatarStandardCard:
            return CardNetworkVariant.VisaSignature;
        default:
            return CardNetworkVariant.Unspecified;
    }
}
/**
 * true for brands where both physical and virtual card numbers are 1:1
 */
function getHasUnifiedCardNumber(productSlug) {
    switch (productSlug) {
        case ProductSlug.CoinbaseCard:
            return true;
        default:
            return false;
    }
}
/**
 * PIN entry is required for cash-advance transactions (and will be for debit
 * cards once those exist), so cash-advance eligibility is the right proxy for
 * whether a product needs physical card PIN management at all.
 */
function getCanChangePhysicalCardPin(features) {
    return features.cashAdvanceEnabled;
}
function getCardNumberDigitCount(cardNetwork) {
    switch (cardNetwork) {
        case CardNetwork.AmericanExpress:
            return 15;
        default:
            return 16;
    }
}
function getCardSecurityCodeDigitCount(cardNetwork) {
    switch (cardNetwork) {
        case CardNetwork.AmericanExpress:
            return 4;
        default:
            return 3;
    }
}
var CardPackagingType;
(function (CardPackagingType) {
    CardPackagingType["Unspecified"] = "CARD_PACKAGING_TYPE_UNSPECIFIED";
    CardPackagingType["StandardPackaging"] = "STANDARD_PACKAGING";
    CardPackagingType["Mirror"] = "MIRROR";
    CardPackagingType["Influencer"] = "INFLUENCER";
    CardPackagingType["BlackRadial"] = "BLACK_RADIAL";
    CardPackagingType["CopperRadial"] = "COPPER_RADIAL";
    CardPackagingType["WhiteRadial"] = "WHITE_RADIAL";
})(CardPackagingType || (CardPackagingType = {}));
/**
 * DLS slug per card packaging type, shared by digital-card tokens and S3 card
 * art keys. A packaging type without an entry has no DLS or card art variant
 */
const CARD_PACKAGING_TOKEN_MAP = {
    [CardPackagingType.BlackRadial]: 'black-radial',
    [CardPackagingType.CopperRadial]: 'copper-radial',
    [CardPackagingType.WhiteRadial]: 'white-radial',
};
const getCardPackagingTokenIdentifier = (cardPackagingType) => {
    if (!cardPackagingType)
        return undefined;
    const map = CARD_PACKAGING_TOKEN_MAP;
    return map[cardPackagingType];
};
/** What CX calls each packaging type */
const CARD_PACKAGING_TYPE_TO_UI_LABEL = {
    [CardPackagingType.StandardPackaging]: 'Standard',
    [CardPackagingType.Mirror]: 'Mirror',
    [CardPackagingType.Influencer]: 'Influencer',
    [CardPackagingType.BlackRadial]: 'Black radial',
    [CardPackagingType.CopperRadial]: 'Copper radial',
    [CardPackagingType.WhiteRadial]: 'White radial',
};
/**
 * Card designs each product offers, mirroring the backend's `CardDesignConfigs`. The first design is
 * the product's default. A product without an entry has one fixed design
 */
const PRODUCT_SLUG_TO_CARD_DESIGNS = {
    [ProductSlug.BiltObsidianCard]: {
        designs: [CardPackagingType.StandardPackaging],
    },
    [ProductSlug.BiltObsidianCardConversion]: {
        designs: [CardPackagingType.StandardPackaging],
    },
    [ProductSlug.BiltPalladiumCard]: {
        designs: [CardPackagingType.StandardPackaging, CardPackagingType.Mirror],
    },
    [ProductSlug.BiltPalladiumCardConversion]: {
        designs: [CardPackagingType.StandardPackaging, CardPackagingType.Mirror],
    },
    [ProductSlug.CoinbaseCard]: {
        designs: [
            CardPackagingType.StandardPackaging,
            CardPackagingType.Influencer,
        ],
    },
    [ProductSlug.KrakenCard]: {
        designs: [CardPackagingType.CopperRadial, CardPackagingType.BlackRadial],
        securedDesigns: [CardPackagingType.WhiteRadial],
    },
};
const getSelectableCardDesigns = (productSlug, secured = false) => {
    const config = productSlug && PRODUCT_SLUG_TO_CARD_DESIGNS[productSlug];
    if (!config)
        return [];
    return (secured && config.securedDesigns) || config.designs;
};
export { getAuthProductUrlForBrand, getBrandIdForBrand, getBrandIdForIdentifier, getBrandIdForProduct, getBrandSlugForIdentifier, getCanChangePhysicalCardPin, getCardPackagingTokenIdentifier, getCardNumberDigitCount, getCardSecurityCodeDigitCount, getCreditCardNetworkForProductId, getCreditCardNetworkVariantForProductId, getHasUnifiedCardNumber, getPriorCardIssuerConfigForIdentifier, getProductAccountType, getProductIdForIdentifier, getProductPointsType, getProductSlugForIdentifier, getSelectableCardDesigns, getProductIdFromPath, getStartsWithVowel, getUIBrandLabels, getUIBrandLoyaltyProgram, getUIBrandLoyaltyFormConfig, getUIBrandName, getUIBrandShortName, getUIProductLabels, getUIProductName, getUIProductShortName, isBrandSlug, isBrandId, isCashBackProduct, isLatamCheckoutCampaign, isProductCategoryTravel, isProductSlug, isProductId, isSunsettedProduct, BRAND_ID_TO_SLUG, BRAND_ID_TO_UI_LABELS, BRAND_SLUG_TO_ID, PRODUCT_MAP, PRODUCT_POINTS_TYPES, PRODUCT_SLUG_TO_ACCOUNT_TYPE, PRODUCT_ID_TO_SLUG, PRODUCT_SLUG_TO_APP_STORE_CONFIG, PRODUCT_SLUG_TO_BRAND_ID, PRODUCT_SLUG_TO_ID, PRODUCT_SLUG_TO_UI_LABELS, SUNSETTED_PRODUCTS, BRAND_UUID_TO_CARD_NETWORK, CARD_PACKAGING_TOKEN_MAP, CARD_PACKAGING_TYPE_TO_UI_LABEL, PRODUCT_ID_TO_CARD_NETWORK_VARIANT, TRAVEL_PRODUCTS, AccountType, BrandId, BrandSlug, CardNetwork, CardNetworkVariant, CardPackagingType, ProductId, ProductSlug, CASH_BACK_PRODUCTS, };
